// Site languages: the first one is the default (x-default in hreflang).
// Each one has src/translate/<code>/translation.json
export const LANGUAGES = ['en', 'ru', 'es', 'pt', 'fr', 'de', 'ko', 'ja', 'it', 'pl', 'tr', 'th'];
export const DEFAULT_LANGUAGE = 'en';
export const SITE_URL = 'https://chernykh.tech';

// <html lang> / hreflang code -> og:locale
export const OG_LOCALES = {
  en: 'en_US',
  ru: 'ru_RU',
  es: 'es_ES',
  pt: 'pt_BR',
  fr: 'fr_FR',
  de: 'de_DE',
  ko: 'ko_KR',
  ja: 'ja_JP',
  it: 'it_IT',
  pl: 'pl_PL',
  tr: 'tr_TR',
  th: 'th_TH',
};

const STORAGE_KEY = 'lang';

// Browser languages without their own version that get the Russian one
const RUSSIAN_SPEAKING = ['kk', 'be', 'ky'];

export const isLanguage = (code) => LANGUAGES.includes(code);

const readStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isLanguage(stored) ? stored : null;
  } catch (e) {
    return null;
  }
};

export const storeLanguage = (lang) => {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {
    // storage unavailable (private mode) — the language still lives in the URL
  }
};

// 'pt-BR' -> 'pt', 'kk-KZ' -> 'ru', 'zh-CN' -> null
const matchBrowserLocale = (locale) => {
  const base = locale.toLowerCase().split(/[-_]/)[0];
  if (isLanguage(base)) return base;
  return RUSSIAN_SPEAKING.includes(base) ? 'ru' : null;
};

// The last language the visitor opened, then the browser languages in order, then English
export const detectLanguage = () => {
  const stored = readStoredLanguage();
  if (stored) return stored;
  const locales = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  for (const locale of locales) {
    const match = locale && matchBrowserLocale(locale);
    if (match) return match;
  }
  return DEFAULT_LANGUAGE;
};

// Link preview images (public/og) exist in Russian and English
export const ogLanguage = (lang) => (lang === 'ru' ? 'ru' : 'en');

// ('ru', '/') -> '/ru/', ('ru', '/physics') -> '/ru/physics'
export const buildPath = (lang, rest = '/') => `/${lang}${rest === '/' ? '/' : rest}`;

export const buildUrl = (lang, rest) => `${SITE_URL}${buildPath(lang, rest)}`;
